/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { getCurrentUser } from 'state/current-user/selectors';
import { Stack } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import Card from 'components/card';
import DateTime from 'components/date-time';

const VisualDeckDetailsCard = ({ visualDeckType, visualDeckExpiry, additionalLicenses }) => {
	return (
		<Card>
			<Stack>
				<Card.Section>
					<DetailListItem label='Visual Deck expiry date' detail={<DateTime date={visualDeckExpiry} format='Do MMM, YYYY' />} />
				</Card.Section>
			</Stack>
		</Card>
	);
};

export default connect((state) => {
	let user = getCurrentUser(state);
	return {
		visualDeckType: user && user.visualDeckType,
		additionalLicenses: user && user.additionalLicenses,
		visualDeckExpiry: user && user.visualDeckExpiry,
	};
}, {})(VisualDeckDetailsCard);
